// Tiny silent WAV used to "unlock" an <audio> element within a user gesture so a
// later programmatic play() (after an async TTS fetch) is not blocked by autoplay policy.
export const SILENT_WAV =
  "data:audio/wav;base64,UklGRiwAAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQgAAACAgICAgICAgA==";

// Call this synchronously inside the click handler, before any await.
export function primeAudio(audio) {
  try {
    audio.src = SILENT_WAV;
    const p = audio.play();
    if (p && p.catch) p.catch(() => {});
  } catch (e) {
    // ignore
  }
}
